import React, { useEffect, useState } from "react";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Moment from "moment";
import MeetingRating from "../../../Rating/Rating";
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom';  

const RmMeetingView = ({
  viewActivity,
  activityByIdDetails = [],
  match,
  addTaggedAlong,
  getRmViewDetails,
  getRmDetails = [],
  ratingSave,
  activityList,
  savedRating = []
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [roleId, setRoleId] = useState("");
  const [openRatingModel, setOpenRatingModel] = useState(false);
  const [meetingId, setMeetingId] = useState("");
  const history = useHistory(); 

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewActivity(match?.params?.id);
      setIsLoading(false);
    })();

    setUserId(window.localStorage.user_id);
    setRoleId(window.localStorage.role_id);
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
        await getRmViewDetails(1);
      setIsLoading(false);
    })();
  }, []);

  const handleSefTaggedAlong = async (e, id) => {
    e.preventDefault();
    let req = {};
    req["id"] = id;
    req["tagged_along"] = window.localStorage.user_id;
    setIsLoading(true);
    await addTaggedAlong(req);
    setIsLoading(false);
  };

  useEffect(() => {
    if(savedRating?.status_code && parseInt(savedRating?.status_code) === 200){
      // console.log("SIMON GO BACK!!")
      // return false;
        toast.success("Rating is marked successfully");
        history.push('/rm-details');


        // (async ()=> {
        //     setOpenRatingModel(false)
        //     setIsLoading(true)
        //     await activityList('lead', match?.params?.id)
        //     setIsLoading(false)

        // })()
    }else if(savedRating?.status_code && parseInt(savedRating?.status_code) !== 200) {
        toast.warning(savedRating?.message);
        setOpenRatingModel(false)
    }
}, [savedRating])

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity"} />
            {/*BODY*/}
            <div className="container-fluid">
              {/*Heading*/}
              <div className="hide d-sm-flex align-items-center justify-content-between com-heading">
                <h1 className="h3 mb-0 text-black-100">Add Account</h1>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-0 bg-white">
                    <div className="div-com-header"></div>
                    {openRatingModel ? (
                      <div className="popup-box">
                        <div className="box">
                          <MeetingRating
                            id={meetingId}
                            ratingSave={ratingSave}
                            loadApi={getRmViewDetails}
                            setOpenRatingModel={setOpenRatingModel}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="card-body">
                        <div className="user">
                          <div className="form-group row">
                            {activityByIdDetails?.data?.activity_name !==
                              null &&
                              activityByIdDetails?.data?.activity_name !== "" &&
                              activityByIdDetails?.data?.activity_name !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.activity_name
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Activity Name
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.activity_date !==
                              null &&
                              activityByIdDetails?.data?.activity_date !== "" &&
                              activityByIdDetails?.data?.activity_date !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={Moment(
                                      activityByIdDetails?.data?.activity_date
                                    ).format("DD-MM-YYYY HH:mm:ss")}
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Activity Date
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.account_details !== null &&
                                activityByIdDetails?.data?.account_details !== "" && activityByIdDetails?.data?.account_details &&
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input type="text"
                                         className="form-control form-control-user"
                                         placeholder=" "
                                         onChange={(e) => {
                                           // handlePocInput(e.target.value, 'city', i)
                                         }}
                                         value={activityByIdDetails?.data?.account_details?.client_name}
                                         disabled={true}
                                  />
                                  <label
                                      className="large-label float-lb">
                                     {activityByIdDetails?.data?.account_details?.fast_tag_toll_no ? "Toll Name" : "Client Name"}
                                  </label>
                                </div>
                            }

                            {activityByIdDetails?.data?.account_details !== null &&
                                activityByIdDetails?.data?.account_details !== "" && activityByIdDetails?.data?.account_details &&
                                activityByIdDetails?.data?.account_details?.fast_tag_toll_no &&
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input type="text"
                                         className="form-control form-control-user"
                                         placeholder=" "
                                         onChange={(e) => {
                                           // handlePocInput(e.target.value, 'city', i)
                                         }}
                                         value={activityByIdDetails?.data?.account_details?.fast_tag_toll_no}
                                         disabled={true}
                                  />
                                  <label
                                      className="large-label float-lb">
                                    Plaza No
                                  </label>
                                </div>
                            }
                            {activityByIdDetails?.data?.cReason !== undefined &&
                              activityByIdDetails?.data?.cReason !== "" && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <label style={{ color: "#1b7cef" }}>
                                    Reason
                                  </label>
                                  <textarea
                                    className="form-control form-control-user cus-red mb-4"
                                    placeholder="Remark"
                                    value={activityByIdDetails?.data?.cReason}
                                    rows="4"
                                    cols="50"
                                  />
                                </div>
                              )}
                            {activityByIdDetails?.data?.pitched_name !==
                              undefined &&
                              activityByIdDetails?.data?.pitched_name !==
                                "" && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <label style={{ color: "#1b7cef" }}>
                                    Pitched
                                  </label>
                                  <textarea
                                    className="form-control form-control-user cus-red mb-4"
                                    placeholder="Pitched"
                                    value={
                                      activityByIdDetails?.data?.pitched_name
                                    }
                                    rows="4"
                                    cols="50"
                                    disabled={true}
                                  />
                                </div>
                              )}
                            {activityByIdDetails?.data?.next_activity_type !==
                              null &&
                              activityByIdDetails?.data?.next_activity_type !==
                                "" &&
                              activityByIdDetails?.data?.next_activity_type !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data
                                        ?.next_activity_type
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Next Activity Name
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.next_activity_date !==
                              null &&
                              activityByIdDetails?.data?.next_activity_date !==
                                "" &&
                              activityByIdDetails?.data?.next_activity_date !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={Moment(
                                      activityByIdDetails?.data
                                        ?.next_activity_date
                                    ).format("DD-MM-YYYY")}
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Next Activity Date
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.is_deal_won !== null &&
                              activityByIdDetails?.data?.is_deal_won !== "" &&
                              activityByIdDetails?.data?.is_deal_won !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.is_deal_won
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Is Deal Won
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.is_dropped !== null &&
                              activityByIdDetails?.data?.is_dropped !== "" &&
                              activityByIdDetails?.data?.is_dropped !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.is_dropped
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Is Dropped
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.dropped_reason !==
                              null &&
                              activityByIdDetails?.data?.dropped_reason !==
                                "" &&
                              activityByIdDetails?.data?.dropped_reason !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.dropped_reason
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Dropped Reason
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.closure_date !== null &&
                              activityByIdDetails?.data?.closure_date !== "" &&
                              activityByIdDetails?.data?.closure_date !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={Moment(
                                      activityByIdDetails?.data?.closure_date
                                    ).format("DD-MM-YYYY HH:mm:ss")}
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Closure Date
                                  </label>
                                </div>
                              )}

                            {activityByIdDetails?.data?.created_name !== null &&
                              activityByIdDetails?.data?.created_name !== "" &&
                              activityByIdDetails?.data?.created_name !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.created_name
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Created By
                                  </label>
                                </div>
                              )}

                            {activityByIdDetails?.data?.assgined_to !== null &&
                              activityByIdDetails?.data?.assgined_to !== "" &&
                              activityByIdDetails?.data?.assgined_to !==
                                undefined && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.assgined_to
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    Assigned By
                                  </label>
                                </div>
                              )}

                            {activityByIdDetails?.data?.agreement !== null &&
                              activityByIdDetails?.data?.agreement !== "" &&
                              activityByIdDetails?.data?.agreement !==
                                undefined && (
                                <>
                                  <label className="agrement-cheque">
                                    Agreement
                                  </label>
                                  <div className="col-sm-6 col-md-3 mt-1 float-field">
                                    <img
                                      src={activityByIdDetails?.data?.agreement}
                                      alt={""}
                                    />
                                  </div>
                                </>
                              )}
                            {activityByIdDetails?.data?.cheque !== null &&
                              activityByIdDetails?.data?.cheque !== "" &&
                              activityByIdDetails?.data?.cheque !== undefined &&
                              activityByIdDetails?.data?.cheque.map(
                                (val, i) => {
                                  return (
                                    <>
                                      <label className="agrement-cheque">
                                        Cheque
                                      </label>
                                      <div className="col-sm-6 col-md-3 mt-1 float-field">
                                        <img src={val?.url} alt={""} />
                                      </div>
                                    </>
                                  );
                                }
                              )}
                            {activityByIdDetails?.data?.description !== null &&
                              activityByIdDetails?.data?.description !== "" &&
                              activityByIdDetails?.data?.description !==
                                undefined && (
                                <>
                                  <div className="col-sm-6 col-md-3 mt-1 float-field">
                                    <label style={{ color: "#1b7cef" }}>
                                      Description
                                    </label>
                                    <textarea
                                      className="form-control form-control-user cus-red mb-4"
                                      placeholder="Remark"
                                      value={
                                        activityByIdDetails?.data?.description
                                      }
                                      rows="4"
                                      cols="50"
                                      // disabled={true}
                                    />
                                  </div>
                                </>
                              )}

                            {activityByIdDetails?.data?.meta_data !== null &&
                              activityByIdDetails?.data?.meta_data !== "" &&
                              activityByIdDetails?.data?.meta_data !==
                                undefined &&
                              activityByIdDetails?.data?.meta_data[0] !==
                                undefined &&
                              activityByIdDetails?.data?.meta_data[0] !==
                                null &&
                              Object.keys(
                                activityByIdDetails?.data?.meta_data[0]
                              )?.map((val, i) => {
                                return (
                                  <>
                                    {val === "Document" &&
                                    activityByIdDetails?.data?.meta_data[0][
                                      val
                                    ] !== null &&    activityByIdDetails?.data?.meta_data[0][
                                      val
                                    ] !== "" ? (
                                      activityByIdDetails?.data?.meta_data[0][
                                        val
                                      ]?.map((img, ii) => {
                                        return <img src={img} alt={""} />;
                                      })
                                    ) : val === "Agreement" ||
                                      val === "GST Certificate" ||
                                      val === "Canceled cheque" ||
                                      val === "Pan Card" ? (
                                      <>
                                        <label style={{ color: "#1b7cef" }}>
                                          {val}
                                        </label>
                                        <img
                                          src={
                                            activityByIdDetails?.data
                                              ?.meta_data[0][val]
                                          }
                                          alt={""}
                                        />
                                      </>
                                    ) : val !== "Document" &&
                                      val !== "Operation Days" &&
                                      val !== "remark" &&
                                      val !== "Remark" &&
                                      val !== "Tagged Along" &&
                                      !val.split("_").includes("id") &&
                                      String(
                                        activityByIdDetails?.data?.meta_data[0][
                                          val
                                        ]
                                      ).split(" ").length <= 6 ? (
                                      <div className="col-sm-6 col-md-3 float-field">
                                        <input
                                          type="text"
                                          className="form-control form-control-user"
                                          placeholder=" "
                                          onChange={(e) => {
                                            // handlePocInput(e.target.value, 'city', i)
                                          }}
                                          value={
                                            activityByIdDetails?.data
                                              ?.meta_data[0][val]
                                          }
                                          disabled={true}
                                        />
                                        <label className="large-label float-lb">
                                          {val.replaceAll("_", " ")}
                                        </label>
                                      </div>
                                    ) : (val === "Remark" ||
                                        val === "remark" ||
                                        val === "Operation Days" ||
                                        (val === "Tagged Along" &&
                                          activityByIdDetails?.data
                                            ?.meta_data[0][val].length > 0) ||
                                        (activityByIdDetails?.data
                                          ?.meta_data[0] !== undefined &&
                                          activityByIdDetails?.data
                                            ?.meta_data[0][val] !== undefined &&
                                          activityByIdDetails?.data
                                            ?.meta_data[0][val] !== null &&
                                          String(
                                            activityByIdDetails?.data
                                              ?.meta_data[0][val]
                                          ).split(" ").length > 6)) &&
                                      !val.split("_").includes("id") ? (
                                      <div className="col-sm-6 col-md-3 float-field">
                                        <label style={{ color: "#1b7cef" }}>
                                          {val[0].toUpperCase() + val.slice(1)}
                                        </label>
                                        <textarea
                                          className="form-control form-control-user cus-red mb-4"
                                          placeholder={val}
                                          value={
                                            activityByIdDetails?.data
                                              ?.meta_data[0][val]
                                          }
                                          rows="4"
                                          cols="50"
                                          // disabled={true}
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                );
                              })}

                            {activityByIdDetails?.data?.approved_name !==
                              null &&
                              parseInt(
                                activityByIdDetails?.data?.approve_rejected_by
                              ) !==
                                parseInt(
                                  activityByIdDetails?.data?.created_by
                                ) && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={
                                      activityByIdDetails?.data?.approved_name
                                    }
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    {parseInt(
                                      activityByIdDetails?.data?.approval_status
                                    ) === 2
                                      ? "Approved"
                                      : "Rejected"}{" "}
                                    By
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data
                              ?.approve_rejected_date !== null &&
                              parseInt(
                                activityByIdDetails?.data?.approve_rejected_by
                              ) !==
                                parseInt(
                                  activityByIdDetails?.data?.created_by
                                ) && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      // handlePocInput(e.target.value, 'city', i)
                                    }}
                                    value={Moment(
                                      activityByIdDetails?.data
                                        ?.approve_rejected_date
                                    ).format("DD-MM-YYYY HH:mm:ss")}
                                    disabled={true}
                                  />
                                  <label className="large-label float-lb">
                                    {parseInt(
                                      activityByIdDetails?.data?.approval_status
                                    ) === 2
                                      ? "Approved"
                                      : "Rejected"}{" "}
                                    Date
                                  </label>
                                </div>
                              )}
                            {activityByIdDetails?.data?.commercial_type !==
                              null && (
                              <div className="col-sm-6 col-md-3 mt-1 float-field">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    // handlePocInput(e.target.value, 'city', i)
                                  }}
                                  value={
                                    activityByIdDetails?.data?.commercial_type
                                  }
                                  disabled={true}
                                />
                                <label className="large-label float-lb">
                                  Commercial Type
                                </label>
                              </div>
                            )}
                            {activityByIdDetails?.data?.payment_type !==
                              null && (
                              <div className="col-sm-6 col-md-3 mt-1 float-field">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    // handlePocInput(e.target.value, 'city', i)
                                  }}
                                  value={
                                    activityByIdDetails?.data?.payment_type
                                  }
                                  disabled={true}
                                />
                                <label className="large-label float-lb">
                                  Payment Type
                                </label>
                              </div>
                            )}

                            {activityByIdDetails?.data?.payment_amount !==
                              null && (
                              <div className="col-sm-6 col-md-3 mt-1 float-field">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    // handlePocInput(e.target.value, 'city', i)
                                  }}
                                  value={
                                    activityByIdDetails?.data?.payment_amount
                                  }
                                  disabled={true}
                                />
                                <label className="large-label float-lb">
                                  Payment Amount
                                </label>
                              </div>
                            )}
                            {activityByIdDetails?.data?.tagged_users !==
                              undefined && (
                              <div className="col-sm-6 col-md-3 float-field">
                                <label style={{ color: "#1b7cef" }}>
                                  Tagged Along
                                </label>
                                <textarea
                                  className="form-control form-control-user cus-red mb-4"
                                  placeholder="Remark"
                                  value={
                                    activityByIdDetails?.data?.tagged_users
                                  }
                                  rows="4"
                                  cols="50"
                                  disabled={true}
                                />
                              </div>
                            )}

                            {activityByIdDetails?.data?.gate_details &&
                              activityByIdDetails?.data?.gate_details?.length >
                                0 &&
                              activityByIdDetails?.data?.gate_details.map(
                                (val, i) => {
                                  return (
                                    <>
                                      {val?.Gate_Name !== null &&
                                        val?.Gate_Name !== "" && (
                                          <>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={val?.Gate_Name}
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Gate Type
                                              </label>
                                            </div>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={val?.gate_quantity}
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Gate Quantity
                                              </label>
                                            </div>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={val?.gate_amount}
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Per Gate Amount
                                              </label>
                                            </div>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={
                                                  val?.Installation_Cost !==
                                                  undefined
                                                    ? val?.Installation_Cost
                                                    : activityByIdDetails?.data
                                                        ?.installation_cost
                                                }
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Per Gate Installation Cost
                                              </label>
                                            </div>
                                          </>
                                        )}
                                    </>
                                  );
                                }
                              )}
                            {activityByIdDetails?.data?.tag_details &&
                              activityByIdDetails?.data?.tag_details.length >
                                0 &&
                              activityByIdDetails?.data?.tag_details.map(
                                (val, i) => {
                                  return (
                                    <>
                                      {val?.tag_name &&
                                        val?.tag_name !== "" && (
                                          <>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={val?.tag_name}
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Tag Type
                                              </label>
                                            </div>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={val?.Tag_Quantity}
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Tag Quantity
                                              </label>
                                            </div>
                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                              <input
                                                type="text"
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handlePocInput(e.target.value, 'city', i)
                                                }}
                                                value={val?.Tag_Amount}
                                                disabled={true}
                                              />
                                              <label className="large-label float-lb">
                                                Per Tag Amount
                                              </label>
                                            </div>
                                          </>
                                        )}
                                    </>
                                  );
                                }
                              )}
                            {activityByIdDetails?.data?.purpose_of_visit &&
                              activityByIdDetails?.data?.purpose_of_visit
                                .length > 0 &&
                              activityByIdDetails?.data?.purpose_of_visit.map(
                                (val, i) => {
                                  return (
                                    <>
                                      {val?.visit_purpose !== null && (
                                        <>
                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                            <input
                                              type="text"
                                              className="form-control form-control-user"
                                              placeholder=" "
                                              onChange={(e) => {
                                                // handlePocInput(e.target.value, 'city', i)
                                              }}
                                              value={val?.visit_purpose}
                                              disabled={true}
                                            />
                                            <label className="large-label float-lb">
                                              Purpose of Visit
                                            </label>
                                          </div>
                                          {(val?.visit_purpose ===
                                            "New Product" ||
                                            val?.visit_purpose ===
                                              "New Dealer") &&
                                            activityByIdDetails?.data
                                              ?.pitched &&
                                            activityByIdDetails?.data?.pitched
                                              .length > 0 &&
                                            activityByIdDetails?.data?.pitched.map(
                                              (val, i) => {
                                                return (
                                                  <>
                                                    {val?.pitched !== null &&
                                                      val?.pitched !==
                                                        undefined && (
                                                        <>
                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                // handlePocInput(e.target.value, 'city', i)
                                                              }}
                                                              value={
                                                                val?.pitched
                                                              }
                                                              disabled={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Pitched
                                                            </label>
                                                          </div>

                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                // handlePocInput(e.target.value, 'city', i)
                                                              }}
                                                              value={
                                                                val?.status
                                                              }
                                                              disabled={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Status
                                                            </label>
                                                          </div>
                                                        </>
                                                      )}
                                                  </>
                                                );
                                              }
                                            )}
                                        </>
                                      )}

                                      {activityByIdDetails?.data
                                        ?.client_stage &&
                                        activityByIdDetails?.data
                                          ?.client_stage !== undefined &&
                                        activityByIdDetails?.data?.client_stage[
                                          i
                                        ] !== undefined && (
                                          <>
                                            {activityByIdDetails?.data
                                              ?.client_stage[i]?.stage !==
                                              undefined &&
                                              activityByIdDetails?.data
                                                ?.client_stage[i]?.stage !==
                                                null && (
                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                  <input
                                                    type="text"
                                                    className="form-control form-control-user"
                                                    placeholder=" "
                                                    onChange={(e) => {
                                                      // handlePocInput(e.target.value, 'city', i)
                                                    }}
                                                    value={
                                                      activityByIdDetails?.data
                                                        ?.client_stage[i].stage
                                                    }
                                                    disabled={true}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Stage
                                                  </label>
                                                </div>
                                              )}

                                            {activityByIdDetails?.data
                                              ?.client_stage[i]
                                              ?.closure_stage !== undefined &&
                                              activityByIdDetails?.data
                                                ?.client_stage[i]
                                                ?.closure_stage !== null && (
                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                  <input
                                                    type="text"
                                                    className="form-control form-control-user"
                                                    placeholder=" "
                                                    onChange={(e) => {
                                                      // handlePocInput(e.target.value, 'city', i)
                                                    }}
                                                    value={
                                                      activityByIdDetails?.data
                                                        ?.client_stage[i]
                                                        .closure_stage
                                                    }
                                                    disabled={true}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Closure Stage
                                                  </label>
                                                </div>
                                              )}
                                          </>
                                        )}

                                      {activityByIdDetails?.data
                                        ?.designation !== null &&
                                        activityByIdDetails?.data
                                          ?.designation !== undefined &&
                                        activityByIdDetails?.data?.designation[
                                          i
                                        ] !== undefined && (
                                          <>
                                            {activityByIdDetails?.data
                                              ?.designation[i]?.designation !==
                                              undefined &&
                                              activityByIdDetails?.data
                                                ?.designation[i]
                                                ?.designation !== null && (
                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                  <input
                                                    type="text"
                                                    className="form-control form-control-user"
                                                    placeholder=" "
                                                    onChange={(e) => {
                                                      // handlePocInput(e.target.value, 'city', i)
                                                    }}
                                                    value={
                                                      activityByIdDetails?.data
                                                        ?.designation[i]
                                                        .designation
                                                    }
                                                    disabled={true}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Designation
                                                  </label>
                                                </div>
                                              )}
                                            {activityByIdDetails?.data
                                              ?.designation[i]?.other !==
                                              undefined &&
                                              activityByIdDetails?.data
                                                ?.designation[i]?.other !==
                                                null && (
                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                  <input
                                                    type="text"
                                                    className="form-control form-control-user"
                                                    placeholder=" "
                                                    onChange={(e) => {
                                                      // handlePocInput(e.target.value, 'city', i)
                                                    }}
                                                    value={
                                                      activityByIdDetails?.data
                                                        ?.designation[i].other
                                                    }
                                                    disabled={true}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Other Designation
                                                  </label>
                                                </div>
                                              )}
                                          </>
                                        )}
                                      {activityByIdDetails?.data
                                        ?.meeting_outcome !== null &&
                                        activityByIdDetails?.data
                                          ?.meeting_outcome !== undefined &&
                                        activityByIdDetails?.data
                                          ?.meeting_outcome !== [] &&
                                        activityByIdDetails?.data
                                          ?.meeting_outcome[i] !== undefined &&
                                        Object.keys(
                                          activityByIdDetails?.data
                                            ?.meeting_outcome[i]
                                        ).length > 0 &&
                                        Object.keys(
                                          activityByIdDetails?.data
                                            ?.meeting_outcome[i]
                                        ).map((out, outIndex) => {
                                          return (
                                            <>
                                              <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                <input
                                                  type="text"
                                                  className="form-control form-control-user"
                                                  placeholder=" "
                                                  onChange={(e) => {
                                                    // handlePocInput(e.target.value, 'city', i)
                                                  }}
                                                  value={
                                                    activityByIdDetails?.data
                                                      ?.meeting_outcome[i][out]
                                                  }
                                                  disabled={true}
                                                />
                                                <label className="large-label float-lb">
                                                  {out}
                                                </label>
                                              </div>
                                            </>
                                          );
                                        })}
                                    </>
                                  );
                                }
                              )}

                            {activityByIdDetails?.data?.pitched &&
                              activityByIdDetails?.data?.pitched.length > 0 &&
                              Object.keys(
                                activityByIdDetails?.data?.pitched
                              ).map((val, i) => {
                                if (
                                  activityByIdDetails?.data?.module_type ===
                                  "Dealer"
                                ) {
                                  return (
                                    <div key={i} className="col-12 mb-3">
                                      <div className="card mb-3">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                          <h3
                                            className="mb-0 text-black-100"
                                            style={{
                                              background: "rgb(229 225 225)",
                                            }}
                                          >
                                            <b style={{ color: "#4c8cd8" }}>
                                              Pitched
                                            </b>
                                          </h3>
                                        </div>
                                      </div>
                                      {Object.keys(
                                        activityByIdDetails?.data?.pitched[val]
                                      ).length > 0 &&
                                        Object.keys(
                                          activityByIdDetails?.data?.pitched[
                                            val
                                          ]
                                        ).map((vall, ii) => {
                                          const hasValidEntries =
                                            activityByIdDetails?.data?.pitched[
                                              val
                                            ][vall].some(
                                              (entry) => entry?.pitched
                                            );

                                          if (!hasValidEntries) return null;

                                          const dealerType = vall
                                            .replace("_", " ")
                                            .replace(
                                              /(^\w{1})|(\s+\w{1})/g,
                                              (letter) => letter.toUpperCase()
                                            );

                                          return (
                                            <div key={ii} className="mb-3">
                                              <div className="card mb-3">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                  <h3 className="mb-0 text-black-100">
                                                    <b
                                                      style={{
                                                        color: "#4c8cd8",
                                                      }}
                                                    >
                                                      {dealerType} Pitched
                                                    </b>
                                                  </h3>
                                                </div>
                                                <div className="card-body">
                                                  <div className="row">
                                                    {activityByIdDetails?.data?.pitched[
                                                      val
                                                    ][vall].map(
                                                      (pic, picIndex) =>
                                                        pic?.pitched ? (
                                                          <div
                                                            key={picIndex}
                                                            className="col-md-4 mt-1 float-field"
                                                          >
                                                            <div className="card">
                                                              <div className="card-body">
                                                                <div className="row mb-2">
                                                                  <label className="col-sm-4 col-form-label">
                                                                    Name
                                                                  </label>
                                                                  <div className="col-sm-8">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control form-control-user"
                                                                      placeholder=" "
                                                                      value={
                                                                        pic?.pitched ||
                                                                        "NA"
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                  <label className="col-sm-4 col-form-label">
                                                                    Outcome
                                                                  </label>
                                                                  <div className="col-sm-8">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control form-control-user"
                                                                      placeholder=" "
                                                                      value={
                                                                        pic?.outcome ||
                                                                        "NA"
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                  <label className="col-sm-4 col-form-label">
                                                                    Outcome
                                                                    Stage
                                                                  </label>
                                                                  <div className="col-sm-8">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control form-control-user"
                                                                      placeholder=" "
                                                                      value={
                                                                        pic?.outcomeStage ||
                                                                        "NA"
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                  <label className="col-sm-4 col-form-label">
                                                                    Remark
                                                                  </label>
                                                                  <div className="col-sm-8">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control form-control-user"
                                                                      placeholder=" "
                                                                      value={
                                                                        pic?.remark ||
                                                                        "NA"
                                                                      }
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ) : null
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  );
                                } else {
                                  return (
                                    <>
                                      <div className="col-12 d-sm-flex align-items-center justify-content-between com-sub-heading">
                                        <h1
                                          className="col-12 h3 mb-0 text-black-100 mb-3"
                                          style={{
                                            background: "rgb(229 225 225)",
                                          }}
                                        >
                                          <b style={{ color: "#4c8cd8" }}>
                                            Pitched
                                          </b>
                                        </h1>
                                      </div>
                                      {/*{activityByIdDetails?.data?.pitched[val]['pitched'] !== undefined &&*/}
                                      {/*    <div className="col-sm-6 col-md-3 mt-1 float-field">*/}
                                      {/*        <input type="text"*/}
                                      {/*               className="form-control form-control-user"*/}
                                      {/*               placeholder=" "*/}
                                      {/*               onChange={(e) => {*/}
                                      {/*                   // handlePocInput(e.target.value, 'city', i)*/}
                                      {/*              }}*/}
                                      {/*               value={activityByIdDetails?.data?.pitched[val]['pitched']}*/}
                                      {/*               disabled={true}*/}
                                      {/*        />*/}
                                      {/*        <label*/}
                                      {/*            className="large-label float-lb">*/}
                                      {/*            {`Pitched ${i+1}`}*/}
                                      {/*        </label>*/}
                                      {/*    </div>*/}
                                      {/*}*/}

                                      {Object.keys(
                                        activityByIdDetails?.data?.pitched[val]
                                      ).length > 0 &&
                                        Object.keys(
                                          activityByIdDetails?.data?.pitched[
                                            val
                                          ]
                                        ).map((vall, ii) => {
                                          return (
                                            <>
                                              {vall === "Upload_proposal" &&
                                                activityByIdDetails?.data
                                                  ?.pitched[val][vall] !==
                                                  null &&
                                                activityByIdDetails?.data
                                                  ?.pitched[val][vall] !==
                                                  undefined && (
                                                  <>
                                                    <label className="agrement-cheque">
                                                      Proposal
                                                    </label>
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      {activityByIdDetails?.data?.pitched[
                                                        val
                                                      ][vall].map(
                                                        (img, index) => {
                                                          return (
                                                            <img
                                                              src={img}
                                                              alt={""}
                                                            />
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </>
                                                )}
                                              {vall !== "pitched" &&
                                                vall !== "Upload_proposal" &&
                                                vall !== "new_dealer" &&
                                                vall !== "service_dealer" &&
                                                vall !== "churn_dealer" && (
                                                  <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      onChange={(e) => {
                                                        // handlePocInput(e.target.value, 'city', i)
                                                      }}
                                                      value={
                                                        activityByIdDetails
                                                          ?.data?.pitched[val][
                                                          vall
                                                        ]
                                                      }
                                                      disabled={true}
                                                    />
                                                    <label className="large-label float-lb">
                                                      {vall
                                                        .replaceAll("_", " ")
                                                        .replace(
                                                          /(^\w{1})|(\s+\w{1})/g,
                                                          (letter) =>
                                                            letter.toUpperCase()
                                                        )}
                                                    </label>
                                                  </div>
                                                )}

                                              {(vall === "new_dealer" ||
                                                vall === "service_dealer" ||
                                                vall === "churn_dealer") && (
                                                <>
                                                  {activityByIdDetails?.data?.pitched[
                                                    val
                                                  ][vall].map(
                                                    (pic, picIndex) => {
                                                      return (
                                                        <>
                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                // handlePocInput(e.target.value, 'city', i)
                                                              }}
                                                              value={
                                                                pic?.pitched
                                                              }
                                                              disabled={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Pitched{" "}
                                                              {vall
                                                                .replaceAll(
                                                                  "_",
                                                                  " "
                                                                )
                                                                .replace(
                                                                  /(^\w{1})|(\s+\w{1})/g,
                                                                  (letter) =>
                                                                    letter.toUpperCase()
                                                                ) +
                                                                " " +
                                                                (picIndex + 1)}
                                                            </label>
                                                          </div>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </>
                                              )}
                                            </>
                                          );
                                        })}
                                    </>
                                  );
                                }
                              })}
                            {(parseInt(roleId) === 42 ||
                              parseInt(roleId) === 6) &&
                              parseInt(activityByIdDetails?.data?.assign_to) !==
                                parseInt(userId) &&
                              parseInt(activityByIdDetails?.data?.status) ===
                                1 && (
                                <a
                                  href={`/complete-dealer-activity/${activityByIdDetails?.data?.dealer_id}`}
                                  onClick={(e) => {
                                    handleSefTaggedAlong(
                                      e,
                                      activityByIdDetails?.data?.id
                                    );
                                  }}
                                >
                                  <i
                                    className="bi bi-check2-circle"
                                    style={{ fontSize: "16px" }}
                                  ></i>
                                  &nbsp;&nbsp;Self Tagged Along
                                </a>
                              )}

                            {activityByIdDetails?.data?.reason !== null &&
                              activityByIdDetails?.data?.reason !== "" &&
                              activityByIdDetails?.data?.reason !== undefined &&
                              activityByIdDetails?.data?.reason.map(
                                (val, i) => {
                                  return (
                                    <>
                                      {val?.primary_product !== undefined &&
                                        val?.primary_product.map(
                                          (prim, primIndex) => {
                                            return (
                                              <>
                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                  <input
                                                    type="text"
                                                    className="form-control form-control-user"
                                                    placeholder=" "
                                                    onChange={(e) => {
                                                      // handlePocInput(e.target.value, 'city', i)
                                                    }}
                                                    value={prim?.reason}
                                                    disabled={true}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Primary Product{" "}
                                                    {++primIndex}
                                                  </label>
                                                </div>
                                                {prim?.lead_status !==
                                                  undefined &&
                                                  prim?.lead_status !== "" &&
                                                  prim?.lead_status !==
                                                    null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          prim?.lead_status
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Lead Status
                                                      </label>
                                                    </div>
                                                  )}
                                                {prim["Price"] !== undefined &&
                                                  prim["Price"] !== "" &&
                                                  prim["Price"] !== null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={prim["Price"]}
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Price quoted
                                                      </label>
                                                    </div>
                                                  )}
                                                {prim["follow_up_date"] !==
                                                  undefined &&
                                                  prim["follow_up_date"] !==
                                                    "" &&
                                                  prim["follow_up_date"] !==
                                                    null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          prim["follow_up_date"]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Follow-Up Date
                                                      </label>
                                                    </div>
                                                  )}
                                                {prim["reason_for_dropout"] !==
                                                  undefined &&
                                                  prim["reason_for_dropout"] !==
                                                    "" &&
                                                  prim["reason_for_dropout"] !==
                                                    null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          prim[
                                                            "reason_for_dropout"
                                                          ]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Reason for dropout
                                                      </label>
                                                    </div>
                                                  )}
                                                {prim[
                                                  "has_the_po_been_signed"
                                                ] !== undefined &&
                                                  prim[
                                                    "has_the_po_been_signed"
                                                  ] !== "" &&
                                                  prim[
                                                    "has_the_po_been_signed"
                                                  ] !== null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          prim[
                                                            "has_the_po_been_signed"
                                                          ]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Has the PO/Contract been
                                                        signed
                                                      </label>
                                                    </div>
                                                  )}
                                                {prim[
                                                  "has_the_cheque_been_received"
                                                ] !== undefined &&
                                                  prim[
                                                    "has_the_cheque_been_received"
                                                  ] !== "" &&
                                                  prim[
                                                    "has_the_cheque_been_received"
                                                  ] !== null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          prim[
                                                            "has_the_cheque_been_received"
                                                          ]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Has the cheque/NEFT been
                                                        received
                                                      </label>
                                                    </div>
                                                  )}
                                              </>
                                            );
                                          }
                                        )}
                                      {val?.add_on_product !== undefined &&
                                        val?.add_on_product.map(
                                          (add, addIndex) => {
                                            return (
                                              <>
                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                  <input
                                                    type="text"
                                                    className="form-control form-control-user"
                                                    placeholder=" "
                                                    onChange={(e) => {
                                                      // handlePocInput(e.target.value, 'city', i)
                                                    }}
                                                    value={add?.reason}
                                                    disabled={true}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Add On Product {++addIndex}
                                                  </label>
                                                </div>
                                                {add["Price"] !== undefined &&
                                                  add["Price"] !== "" &&
                                                  add["Price"] !== null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={add["Price"]}
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Price quoted
                                                      </label>
                                                    </div>
                                                  )}
                                                {add["follow_up_date"] !==
                                                  undefined &&
                                                  add["follow_up_date"] !==
                                                    "" &&
                                                  add["follow_up_date"] !==
                                                    null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          add["follow_up_date"]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Follow-Up Date
                                                      </label>
                                                    </div>
                                                  )}
                                                {add["reason_for_dropout"] !==
                                                  undefined &&
                                                  add["reason_for_dropout"] !==
                                                    "" &&
                                                  add["reason_for_dropout"] !==
                                                    null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          add[
                                                            "reason_for_dropout"
                                                          ]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Reason for dropout
                                                      </label>
                                                    </div>
                                                  )}
                                                {add[
                                                  "has_the_po_been_signed"
                                                ] !== undefined &&
                                                  add[
                                                    "has_the_po_been_signed"
                                                  ] !== "" &&
                                                  add[
                                                    "has_the_po_been_signed"
                                                  ] !== null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          add[
                                                            "has_the_po_been_signed"
                                                          ]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Has the PO/Contract been
                                                        signed
                                                      </label>
                                                    </div>
                                                  )}
                                                {add[
                                                  "has_the_cheque_been_received"
                                                ] !== undefined &&
                                                  add[
                                                    "has_the_cheque_been_received"
                                                  ] !== "" &&
                                                  add[
                                                    "has_the_cheque_been_received"
                                                  ] !== null && (
                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                      <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          // handlePocInput(e.target.value, 'city', i)
                                                        }}
                                                        value={
                                                          add[
                                                            "has_the_cheque_been_received"
                                                          ]
                                                        }
                                                        disabled={true}
                                                      />
                                                      <label className="large-label float-lb">
                                                        Has the cheque/NEFT been
                                                        received
                                                      </label>
                                                    </div>
                                                  )}
                                              </>
                                            );
                                          }
                                        )}
                                      {val?.reason !== undefined && (
                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              // handlePocInput(e.target.value, 'city', i)
                                            }}
                                            value={val?.reason}
                                            disabled={true}
                                          />
                                          <label className="large-label float-lb">
                                            Reason
                                          </label>
                                        </div>
                                      )}
                                    </>
                                  );
                                }
                              )}

                            {activityByIdDetails?.data?.attendance !==
                              undefined &&
                              activityByIdDetails?.data?.attendance
                                ?.approved_rejected_remark !== undefined &&
                              activityByIdDetails?.data?.attendance
                                ?.approved_rejected_remark !== null &&
                              activityByIdDetails?.data?.attendance
                                ?.approved_rejected_remark !== "" && (
                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                  <label style={{ color: "#1b7cef" }}>
                                    Attendance Approved Or Rejection Remark
                                  </label>
                                  <textarea
                                    className="form-control form-control-user cus-red mb-4"
                                    placeholder="Remark"
                                    value={
                                      activityByIdDetails?.data?.attendance
                                        ?.approved_rejected_remark
                                    }
                                    // rows="4" cols="50"
                                  />
                                </div>
                              )}

                            {activityByIdDetails?.data?.attendance !==
                              undefined && (
                              <>
                                {activityByIdDetails?.data?.attendance
                                  ?.check_in_selfie && (
                                  <img
                                    className="col-md-6"
                                    src={
                                      activityByIdDetails?.data?.attendance
                                        ?.check_in_selfie
                                    }
                                    alt={"check_in_selfie"}
                                  />
                                )}
                                {activityByIdDetails?.data?.attendance
                                  ?.check_out_selfie && (
                                  <img
                                    className="col-md-6"
                                    src={
                                      activityByIdDetails?.data?.attendance
                                        ?.check_out_selfie
                                    }
                                    alt={"check_in_selfie"}
                                  />
                                )}
                              </>
                            )}
                            {activityByIdDetails?.data?.product_discussed !==
                              undefined &&
                              activityByIdDetails?.data?.product_discussed !==
                                null &&
                              activityByIdDetails?.data?.product_discussed
                                .length > 0 &&
                              activityByIdDetails?.data?.product_discussed.map(
                                (val, i) => {
                                  return (
                                    <>
                                      {val?.product_discussed !== null && (
                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              // handlePocInput(e.target.value, 'city', i)
                                            }}
                                            value={val?.product_discussed}
                                            disabled={true}
                                          />
                                          <label className="large-label float-lb">
                                            Product Discussed
                                          </label>
                                        </div>
                                      )}
                                      {val?.remark !== null && (
                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                          <label style={{ color: "#1b7cef" }}>
                                            {val?.product_discussed} Remark
                                          </label>
                                          <textarea
                                            className="form-control form-control-user cus-red mb-4"
                                            placeholder="Remark"
                                            value={val?.remark}
                                            rows="4"
                                            cols="50"
                                          />
                                        </div>
                                      )}
                                    </>
                                  );
                                }
                              )}

                            {activityByIdDetails?.data?.fse_details &&
                              activityByIdDetails?.data?.fse_details.length >
                                0 &&
                              activityByIdDetails?.data?.fse_details.map(
                                (val, i) => {
                                  return (
                                    <>
                                      {val !== null && (
                                        <>
                                          <div className="col-sm-6 col-md-3 mt-1 float-field mt-3">
                                            <input
                                              type="text"
                                              className="form-control form-control-user"
                                              placeholder=" "
                                              onChange={(e) => {
                                                // handlePocInput(e.target.value, 'city', i)
                                              }}
                                              value={val?.phone_no}
                                              disabled={true}
                                            />
                                            <label className="large-label float-lb">
                                              FSE Phone
                                            </label>
                                          </div>

                                          <div className="col-sm-6 col-md-3 mt-1 mb-4 float-field">
                                            <img src={val?.selfie} />
                                          </div>
                                        </>
                                      )}
                                    </>
                                  );
                                }
                              )}

                            {activityByIdDetails?.data?.meta_data &&
                              activityByIdDetails?.data?.meta_data[0] &&
                              activityByIdDetails?.data?.meta_data[0]
                                ?.competitor &&
                              Object.keys(
                                activityByIdDetails?.data?.meta_data[0]
                                  ?.competitor
                              ).length > 0 && (
                                <>
                                  {activityByIdDetails?.data?.meta_data[0]?.competitor.map(
                                    (val, i) => {
                                      return (
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div
                                              className="d-sm-flex align-items-center justify-content-between com-sub-heading"
                                              style={{
                                                backgroundColor: "bisque",
                                              }}
                                            >
                                              <h1 className="h3 mb-0 text-black-100">
                                                <b>Competitor Analysis</b>
                                              </h1>
                                            </div>
                                            <div className="card-body bg-white">
                                              <div className="user">
                                                <div className="form-group row">
                                                  <div
                                                    className="col-md-6 float-field "
                                                    key={i}
                                                  >
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      required={true}
                                                      value={val?.name}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Competitor Name
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6 float-field ">
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      required={true}
                                                      value={val?.bank}
                                                    />
                                                    <label className="large-label float-lb">
                                                      FASTag Bank Name
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6 float-field ">
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      value={val?.employee_type}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Employee Type
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6 float-field ">
                                                    <input
                                                      type="number"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      required={true}
                                                      value={val?.no_of_fse}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Number of FSEs
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6 float-field ">
                                                    <input
                                                      type="float"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      required={true}
                                                      value={val?.salary}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Monthly Salary
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6 float-field ">
                                                    <input
                                                      type="float"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      value={val?.min_tags}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Min. Number of tags sold
                                                      to be eligible for salary
                                                    </label>
                                                  </div>
                                                  <div className="col-md-6 float-field ">
                                                    <input
                                                      type="float"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      value={val?.tag_sold}
                                                    />
                                                    <label className="large-label float-lb">
                                                      Monthly tags sold
                                                    </label>
                                                  </div>

                                                  {val?.upload_proof &&
                                                    Object.keys(
                                                      val?.upload_proof
                                                    ).length > 0 &&
                                                    val?.upload_proof.map(
                                                      (value) => {
                                                        return (
                                                          <>
                                                            <div className="col-md-12">
                                                              <img
                                                                src={value}
                                                                alt="proof"
                                                                style={{
                                                                  height:
                                                                    "300px",
                                                                }}
                                                              />
                                                            </div>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </>
                              )}
                          </div>
                        </div>
                        { !(activityByIdDetails?.data?.flag) && (
                          <div
                            className="btn btn-success btn-sm"
                            onClick={() => {
                              setOpenRatingModel(true);
                              setMeetingId(match?.params?.id);
                            }}
                          >
                            Rate
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RmMeetingView;
